"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setToken = exports.getToken = void 0;
const os = require("os");
const fs = require("fs");
const path = require("path");
const readTokenFromHomeDir = (type) => {
    try {
        const env = 'prod';
        // const env = process.__sensecommon.env
        const homeDir = os.homedir();
        const sensecommonFile = path.resolve(homeDir, '.sensecommon');
        console.log('homeDir', homeDir);
        const content = fs.readFileSync(sensecommonFile, 'utf8');
        const obj = {};
        content.split('\n').filter(line => line).forEach(line => {
            const [key, value] = line.split('=');
            obj[key] = value;
        });
        return obj[`${env}_${type}`] || '';
    }
    catch (error) {
        if (error.code !== 'ENOENT') {
            console.log(error);
        }
        return '';
    }
};
const writeTokenFromHomeDir = (type, value) => {
    const env = 'prod';
    // const env = process.__sensecommon.env
    const homeDir = os.homedir();
    const sensecommonFile = path.resolve(homeDir, '.sensecommon');
    console.log('homeDir', homeDir);
    let content = '';
    try {
        content = fs.readFileSync(sensecommonFile, 'utf8');
    }
    catch (error) {
        if (error.code !== 'ENOENT') {
            console.log(error);
            return '';
        }
    }
    if (content) {
        const obj = {};
        content.split('\n').filter(line => line).forEach(line => {
            const [key, value] = line.split('=');
            obj[key] = value;
        });
        obj[`${env}_${type}`] = value;
        content = Object.entries(obj).reduce((prev, cur) => {
            const [key, value] = cur;
            return `${prev}${key}=${value}\n`;
        }, '');
    }
    else {
        content = `${env}_${type}=${value}\n`;
    }
    fs.writeFileSync(sensecommonFile, content, 'utf8');
};
const getTokenInNode = async (type) => {
    const readToken = process.__sensecommon.readToken;
    if (readToken) {
        return await readToken(type);
    }
    else {
        return readTokenFromHomeDir(type);
    }
};
const setTokenInNode = async (type, value) => {
    const writeToken = process.__sensecommon.writeToken;
    if (writeToken) {
        return await writeToken(type, value);
    }
    else {
        return writeTokenFromHomeDir(type, value);
    }
};
const getTokenInWeb = async (type) => {
    // const crossStorage = window.__sensecommon.cs
    // return await crossStorage.getItem(type)
    return await localStorage.getItem(type);
};
const setTokenInWeb = async (type, value) => {
    // const crossStorage = window.__sensecommon.cs
    // return await crossStorage.setItem(type, value)
    return await localStorage.setItem(type, value);
};
exports.getToken = TARGET === 'web' ? getTokenInWeb : getTokenInNode;
exports.setToken = TARGET === 'web' ? setTokenInWeb : setTokenInNode;
